import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", menuOpen);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className="top-bar" id="top">
        <div className="top-bar__inner">
          <div className="logo">
            <Link to="/" onClick={closeMenu}>
              <img
                src="/oganov_luxury_minimal_medical_logo_premium_modern_wordmark_clean_uppercase_typography_high-end_aest_z4a52xt5yxtxwhb1r339_1.png"
                alt="OGANOV"
                className="logo__image"
              />
            </Link>
          </div>
          <button className="burger" aria-label="Меню" onClick={() => setMenuOpen((v) => !v)}>
            <span />
            <span />
            <span />
          </button>
          <nav className={`nav ${menuOpen ? "nav--open" : ""}`}>
            <ul className="nav__links">
              <li>
                <Link className="nav__link nav__link--accent" to="/" onClick={closeMenu}>
                  Главная
                </Link>
              </li>
              <li>
                <Link className="nav__link" to="/#booking" onClick={closeMenu}>
                  Записаться
                </Link>
              </li>
              <li>
                <Link className="nav__link" to="/publications" onClick={closeMenu}>
                  Публикации
                </Link>
              </li>
              <li>
                <Link className="nav__link" to="/about" onClick={closeMenu}>
                  Обо мне
                </Link>
              </li>
            </ul>
            <ul className="nav__icons" aria-label="Контакты">
              <li>
                <a className="icon-link" aria-label="Локация" href="/#booking">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 3.5c-3.1 0-5.5 2.5-5.5 5.6 0 4.2 5.5 11.4 5.5 11.4s5.5-7.2 5.5-11.4C17.5 6 15.1 3.5 12 3.5Zm0 7.3a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6Z" />
                  </svg>
                </a>
              </li>
              <li>
                <a className="icon-link" aria-label="Телефон" href="tel:+79269498006">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M17.9 15.6c-.5-.1-1 .1-1.4.5l-1 1c-1.9-.9-3.4-2.3-4.6-4.1l1-1c.4-.4.6-.9.5-1.4l-.5-3c-.1-.8-.8-1.4-1.6-1.4H7.4c-.9 0-1.6.7-1.6 1.6 0 7 5.7 12.6 12.6 12.6.9 0 1.6-.7 1.6-1.6v-2.9c0-.8-.6-1.5-1.4-1.6l-2.7-.3Z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="icon-link"
                  aria-label="Telegram"
                  href="https://t.me/docneuro1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20.8 4.4c-.2 0-.4 0-.6.1L3.5 10.8c-.4.1-.6.5-.5.9.1.3.3.5.6.6l3.8 1.1 2.2 4.5c.1.3.4.5.7.5h.1c.3 0 .6-.2.7-.5l1.4-3 4.6 2.6c.2.1.4.1.6.1.3 0 .6-.1.8-.3.2-.2.4-.5.4-.8l1.7-11.2c0-.3 0-.6-.2-.8-.2-.3-.6-.5-1-.5Zm-2.4 3.1-8 6.3c-.2.2-.5.2-.7 0l-2.5-2.2 10.6-4.1Z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  className="icon-link"
                  aria-label="WhatsApp"
                  href="https://api.whatsapp.com/send/?phone=79269498006&text&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m5 19.4 1.2-4.1a7 7 0 1 1 2.6 2.5L5 19.4Zm3.3-1.5.3.2a5.8 5.8 0 1 0-2-2l.2.3-.6 1.8 2.1-.3Zm6.5-3.4c-.1-.1-.6-.3-1.2-.6-.6-.3-.9-.3-1 .2-.1.2-.3.3-.5.3-.3.1-.5 0-1-.5-.5-.4-.8-1-1-1.3-.1-.3 0-.4.2-.6.2-.2.3-.4.2-.6 0-.2-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.6.1-1 .5-.3.4-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.2.2 2.2 3.4 5.2 3.4 1.9 0 2.7-.8 3.2-1.2.3-.3.5-.6.6-.9.1-.2.1-.4 0-.5-.1-.1-.5-.2-1-.5Z" />
                  </svg>
                </a>
              </li>
            </ul>
            <div className="nav__socials">
              <a
                className="nav__social-link"
                href="https://t.me/docneuro1"
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.8 4.4c-.2 0-.4 0-.6.1L3.5 10.8c-.4.1-.6.5-.5.9.1.3.3.5.6.6l3.8 1.1 2.2 4.5c.1.3.4.5.7.5h.1c.3 0 .6-.2.7-.5l1.4-3 4.6 2.6c.2.1.4.1.6.1.3 0 .6-.1.8-.3.2-.2.4-.5.4-.8l1.7-11.2c0-.3 0-.6-.2-.8-.2-.3-.6-.5-1-.5Zm-2.4 3.1-8 6.3c-.2.2-.5.2-.7 0l-2.5-2.2 10.6-4.1Z" />
                </svg>
                <span>Telegram</span>
              </a>
              <a
                className="nav__social-link"
                href="https://api.whatsapp.com/send/?phone=79269498006&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noreferrer"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m5 19.4 1.2-4.1a7 7 0 1 1 2.6 2.5L5 19.4Zm3.3-1.5.3.2a5.8 5.8 0 1 0-2-2l.2.3-.6 1.8 2.1-.3Zm6.5-3.4c-.1-.1-.6-.3-1.2-.6-.6-.3-.9-.3-1 .2-.1.2-.3.3-.5.3-.3.1-.5 0-1-.5-.5-.4-.8-1-1-1.3-.1-.3 0-.4.2-.6.2-.2.3-.4.2-.6 0-.2-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.6.1-1 .5-.3.4-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.2.2 2.2 3.4 5.2 3.4 1.9 0 2.7-.8 3.2-1.2.3-.3.5-.6.6-.9.1-.2.1-.4 0-.5-.1-.1-.5-.2-1-.5Z" />
                </svg>
                <span>WhatsApp</span>
              </a>
              <a className="nav__social-link" href="tel:+79269498006">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M17.9 15.6c-.5-.1-1 .1-1.4.5l-1 1c-1.9-.9-3.4-2.3-4.6-4.1l1-1c.4-.4.6-.9.5-1.4l-.5-3c-.1-.8-.8-1.4-1.6-1.4H7.4c-.9 0-1.6.7-1.6 1.6 0 7 5.7 12.6 12.6 12.6.9 0 1.6-.7 1.6-1.6v-2.9c0-.8-.6-1.5-1.4-1.6l-2.7-.3Z" />
                </svg>
                <span>+7 926 949-80-06</span>
              </a>
            </div>
          </nav>
        </div>
      </header>
      <div className={`nav-dim ${menuOpen ? "is-open" : ""}`} onClick={closeMenu} />
    </>
  );
};
